export const getCurrentAdminInfo = () => {
  const token = localStorage.getItem('admin_token');
  if (!token) return null;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return {
      id: payload.id,
      username: payload.username,
      telegramId: payload.telegramId,
      telegramUsername: payload.telegramUsername,
    };
  } catch (error) {
    console.error('Error parsing admin token:', error);
    return null;
  }
}; 